module.exports = __webpack_public_path__ + "img/30-days-challenge-img.7d6949c1.webp";